import { render, staticRenderFns } from "./ChatList2.vue?vue&type=template&id=a530f9bc&scoped=true&"
import script from "./ChatList2.vue?vue&type=script&lang=ts&"
export * from "./ChatList2.vue?vue&type=script&lang=ts&"
import style0 from "./ChatList2.vue?vue&type=style&index=0&id=a530f9bc&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a530f9bc",
  null
  
)

export default component.exports